import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './app';
import Services from './services';
import Legal from './legal';
import Login from './Login';
import Admin from './Admin';
import { LanguageProvider } from './LanguageContext';
import { ThemeProvider } from './ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/services" element={<Services />} />
            <Route path="/legal/:page" element={<Legal />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);